<div id="{{ shop.id }}">
  <div class="shop-name">
    <div class="block section-shop-name">
      <div class="row">
        <div class="column name-section">
          <span class="shop-name-wrapper">{{ index }}.</span>
          <span class="shop-name-wrapper pad-left-5">{{ shop.name }}</span>
        </div>
        @if (shop.tier === 'Tier1') {
          <div class="row shop-type-section certified">
            <div class="column display-preferred-shop pad-right-5" aria-hidden="true">
              <img [src]="starImage" alt="Star" />
            </div>
            <div class="column tooltip">
              {{ isPartner ? 'Preferred VIP Shop' : 'Preferred DRP Shop' }}
              <span class="tooltip-text"
                ><span class="arrow"></span><span class="arrow-white"></span
                >{{
                  isPartner
                    ? 'A Preferred Value
                in Partnership Shop is an auto body shop that has attained the highest ranking in our Value
                in Partnership Program.'
                    : "A Preferred Dreams
                Restored Shop is an auto body shop that has attained the highest ranking in American
                Family's Dreams Restored Program."
                }}</span
              >
            </div>
          </div>
        }
      </div>
    </div>
  </div>

  <div class="shop-photo-line">
    <div class="shop-info-main">
      <div class="shop-info-left pad-left-10">
        @if (shop.distanceInfo) {
          <span class="pad-top-5 shop-type-section">Distance away</span>
        }
        @if (shop.distanceInfo) {
          <span class="shop-type-distance-display"
            >{{ shop.distanceInfo.distance | number: '1.1-1' }} miles</span
          >
        }
        @if (shop.hoursOfOperation) {
          <div>
            <span class="office-hours-style shop-type-section pad-top-10">Opening Hours</span>
            <drp-shop-card-hours [shopHours]="shop.hoursOfOperation"></drp-shop-card-hours>
          </div>
        }
      </div>
      <div class="shop-info-address">
        <span class="neutral-600-text">
          <span dsTabFocus aria-label="Phone Number" class="pseudo-icon icon-call"></span>
          <a class="pad-left-5" href="tel:+1{{ shop.contactMethodDetail.primaryPhoneNumber }}">
            {{ shop.contactMethodDetail.primaryPhoneNumber }}</a
          ></span
        >
        <div class="pad-bottom-5">
          <div class="row pad-top-10">
            <span dsTabFocus aria-label="Location" class="column icon-find"></span>
            <div class="pad-left-20">
              <span class="pad-right-10"> {{ shop.address.addressLine1 }} </span>
            </div>
          </div>
          @if (shop.address.addressLine1) {
            <span class="block">
              {{ shop.address.addressLine2 }}
            </span>
          }
          <span class="block pad-left-20">
            {{ shop.address.city + ', ' + shop.address.state }} {{ shop.address.zipCode }}
          </span>
        </div>
        @if (formattedUrl !== '') {
          <span class="icon-new-page neutral-600-text"></span>
          <a class="pad-left-5" href="{{ formattedUrl }}" target="_blank"
            ><span>Visit Website</span></a
          >
        }
      </div>
    </div>
  </div>
</div>
